import { render, staticRenderFns } from "./ServiceAssessmentPhysicalCheck.vue?vue&type=template&id=2214c740&scoped=true"
import script from "./ServiceAssessmentPhysicalCheck.vue?vue&type=script&lang=js"
export * from "./ServiceAssessmentPhysicalCheck.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssessmentPhysicalCheck.vue?vue&type=style&index=0&id=2214c740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214c740",
  null
  
)

export default component.exports